import * as React from 'react';

function SvgExternalLinkOutlined(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" className="ExternalLinkOutlined_svg__icon" viewBox="0 0 1024 1024" {...props}>
      <path d="M849.74 565.895c-17.066 0-31.438 14.372-31.438 31.438v208.393h-589.25V233.544h222.766c17.066 0 31.438-14.372 31.438-31.439s-14.372-31.438-31.438-31.438H206.596c-22.456 0-41.319 17.965-41.319 41.319v615.298c0 22.456 17.965 41.32 41.32 41.32H839.86c22.456 0 40.42-17.965 40.42-41.32v-229.95c.899-17.067-13.473-31.44-30.54-31.44z" />
      <path d="M532.66 540.744c8.084 0 16.168-2.695 21.558-8.983L812.014 282.05v193.123c0 17.067 14.372 31.439 31.439 31.439s31.438-14.372 31.438-31.44V211.987c0-22.456-17.965-40.421-40.42-40.421H566.792c-17.067 0-31.439 14.372-31.439 31.439s14.372 31.438 31.439 31.438h203.902L510.204 486.85c-12.576 11.677-12.576 32.337-.899 44.014 7.186 6.288 15.27 9.88 23.355 9.88z" />
    </svg>
  );
}

export default SvgExternalLinkOutlined;
